// @ts-strict-ignore
export class ConstraintCheckResult {

  public static readonly PASSED: string = 'PASSED';
  public static readonly WARN: string = 'WARNING';
  public static readonly FAILED: string = 'FAILED';

  public checkResult: string;
  public resultCode: string;
  public checkDetails: string;
  public errorStart: number;
  public errorEnd: number;

  /**
   *
   * Result of a ConstraintCheck, contains a simple boolean result and optional details. (Error messages...)
   *
   * @param resultClass passed, warning or failed
   * @param resultCode
   * @param checkDetails Usually if check failed
   * @param detailsBegin Marks the beginning of the piece of text the details are about
   * @param detailsEnd Marks the ending of the piece of text the details are about
   *
   */
  constructor(resultClass: string, resultCode: string = '', checkDetails: string = null, errorStart: number = -1, errorEnd: number = -1) {
    this.checkResult = resultClass;
    this.resultCode = resultCode;
    this.checkDetails = checkDetails;
    this.errorStart = errorStart;
    this.errorEnd = errorEnd;
  }
}
